import { createSlice } from "@reduxjs/toolkit";
const authSlice = createSlice({
    name: "auth",
    initialState: {
        login: {
            currentUser: null,
            isFetching: false,
            error: false
        },
        register: {
            isFetching: false,
            error: false,
            success: false
        },
        allusers:{
            listusers:null,
            isFetching: false,
            error: false
        },
        // alllogin:{
        //     listlogin:null,
        //     isFetching: false,
        //     error: false
        // },
        edituser:{
            isFetching:false,
            error:false,
            success:false
        },
        deleteuser:{
            isFetching:false,
            error:false,
            success:false
        }
    },
    reducers: {
        deleteUserStart:(state)=>{
            state.deleteuser.isFetching = true;
        },
        deleteUserSuccess:(state)=>{
            state.deleteuser.isFetching = false;
            state.deleteuser.error = false;
            state.deleteuser.success = true;
        },
        deleteUserFailed:(state)=>{
            state.deleteuser.isFetching = false;
            state.deleteuser.error = true;
            state.deleteuser.success = false;
        },
        editUserStart:(state)=>{
            state.edituser.isFetching = true;
        },
        editUserSuccess:(state)=>{
            state.edituser.isFetching = false;
            state.edituser.error = false;
            state.edituser.success = true;
        },
        editUserFailed:(state)=>{
            state.edituser.isFetching = false;
            state.edituser.error = true;
            state.edituser.success = false;
        },
        // getallLoginStart: (state) => {
        //     state.alllogin.isFetching = true;
        // },
        // getallLoginSuccess: (state, action) => {
        //     state.alllogin.isFetching = false;
        //     state.alllogin.listlogin = action.payload;
        //     state.alllogin.error = false;
        // },
        // getallLoginFailed: (state) => {
        //     state.alllogin.isFetching = false;
        //     state.alllogin.error = true;
        // },
        getallUserStart: (state) => {
            state.allusers.isFetching = true;
        },
        getallUserSuccess: (state, action) => {
            state.allusers.isFetching = false;
            state.allusers.listusers = action.payload;
            state.allusers.error = false;
        },
        getallUserFailed: (state) => {
            state.allusers.isFetching = false;
            state.allusers.error = true;
        },
        loginStart: (state) => {
            state.login.isFetching = true;
        },
        loginSuccess: (state, action) => {
            state.login.isFetching = false;
            state.login.currentUser = action.payload;
            state.login.error = false;
        },
        loginFailed: (state) => {
            state.login.isFetching = false;
            state.login.error = true;
        },
        RegisterStart: (state) => {
            state.register.isFetching = true;
        },
        RegisterSuccess: (state) => {
            state.register.isFetching = false;
            state.register.error = false;
            state.register.success = true;
        },
        RegisterFailed: (state) => {
            state.register.isFetching = false;
            state.register.error = true;
            state.register.success = false;
        },
        logoutStart: (state) => {
            state.login.isFetching = true;
        },
        logoutSuccess: (state, action) => {
            state.login.isFetching = false;
            state.login.currentUser = null;
            state.login.error = false;
        },
        logoutFailed: (state) => {
            state.login.isFetching = false;
            state.login.error = true;
        },
    }
})
export const {
    getallUserStart,
    getallUserSuccess,
    getallUserFailed,
    deleteUserStart,
    deleteUserSuccess,
    deleteUserFailed,
    loginStart,
    loginFailed,
    loginSuccess,
    RegisterStart,
    RegisterSuccess,
    RegisterFailed,
    logoutStart,
    logoutSuccess,
    logoutFailed,
    editUserStart,
    editUserSuccess,
    editUserFailed,
} = authSlice.actions;
export default authSlice.reducer;